var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"stage",staticClass:"mbo-stage"},[_c('div',{staticClass:"mbo-stage__canvas",style:({transform: `scale(${_vm.scale})`})},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }